import Vue from "vue";
import App from "./App.vue";
import toastr from "vue-toastr";
import VueI18n from 'vue-i18n'
import LangEn from './language/en_US'
import router from "./router";
import store from "./store";
import config from "./config";
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm.js';

// import './style/bootstrap.min.css'
// import './style/swiper.min.css'
// import './style/kpspecial.css'
import './style/style.scss'
// import './lib/jquery-3.4.1.min.js'
// import './lib/index.js'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import './style/element-variables.scss'
Vue.use(ElementUI, { locale });
import { Loading } from 'element-ui'

import { JSEncrypt } from 'jsencrypt'

var loadingInstance;
// import VeeValidate from 'vee-validate';

// Vue.use(VeeValidate);
Vue.use(VueI18n)
Vue.use(toastr,{
    defaultPosition: 'toast-bottom-center',
})

const i18n = new VueI18n({
    locale: 'en_US',
    messages: {
        'en_US': LangEn,
    }
})

Vue.config.productionTip = false;
Vue.use(DatatableFactory);

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor);

import axios from "axios"
// axios.defaults.headers.post['crossDomain'] = true;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(function (config) {
  loadingInstance = Loading.service({ fullscreen: true });
  return config;
}, function (error) {
  
  loadingInstance.close();
  store.getters.warning.warningMsg = error.message;
  store.getters.warning.warningFalg = true;
  store.getters.warning.button = [{
              name:"Cancel",
              callBack:function(){store.getters.warning.warningFalg = false;}
            }];
  return Promise.reject(error);
})
//获取response error
axios.interceptors.response.use(function (response) {
  loadingInstance.close();
  return response;
}, function (error) {
  if(error.response.status==500){
    store.getters.warning.warningMsg = error.response.data.message;
  }else{
    store.getters.warning.warningMsg = error.message;
  }
  store.getters.warning.warningFalg = true;
  store.getters.warning.button = [{
              name:"Cancel",
              callBack:function(){store.getters.warning.warningFalg = false;}
            }];
  loadingInstance.close();
  return Promise.reject(error);
})
// import interceptorsSetup from './httpInterceptor'
// interceptorsSetup()
// axios.defaults.timeout = 15000;
Vue.prototype.$axios = axios
//获取request error

var mixin = {
  data() {
    return {
      langData: ["English", "Simplified Chinese", "Traditional Chinese"],
      langKey: ["en_US", "zh_HK", "zh_CN"],
      fileUploadUrl: config.fileUploadUrl,
      fileBase64UploadUrl: config.fileBase64UploadUrl,
    }
  }
}


new Vue({
  mixins: [mixin],
  router,
  i18n,
  store,
  toastr,
  axios,
  render: h => h(App)
}).$mount("#app");


